import { Box } from "../box"

export function SectionSpace() {
  return <Box className="mb-12" />
}
